import React from 'react';
import PropTypes from 'prop-types';

function TwitterLogo({ className, width, height, color }) {
  return (
    <svg
      role="img"
      aria-labelledby="twitter-icon-title"
      className={`twitter-icon ${className}`}
      viewBox="0 0 13 14"
      width={width}
      height={height}
    >
      <title id="twitter-icon-title">Twitter Icon</title>
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M13,4.06596 C12.557583,4.24596 12.0855465,4.368 11.586515,4.42236 C12.0926701,4.1412 12.4859714,3.6984 12.6700619,3.16596 C12.1935262,3.42516 11.6648753,3.61596 11.106605,3.7164 C10.6566894,3.2772 10.0155596,3 9.30694245,3 C7.949322,3 6.84702868,4.01916 6.84702868,5.27196 C6.84702868,5.45196 6.86989939,5.6244 6.91076673,5.79 C4.86365057,5.6964 3.05274011,4.78956 1.83834281,3.41796 C1.62463288,3.7524 1.50428045,4.1412 1.50428045,4.55916 C1.50428045,5.3472 1.88520902,6.04236 2.54471037,6.44916 C2.13978629,6.438 1.75210898,6.33396 1.37717928,6.1644 L1.37717928,6.1932 C1.37717928,7.29516 2.27851028,8.2128 3.40329938,8.4216 C3.19708805,8.47236 3.00662376,8.5008 2.78204087,8.5008 C2.62457039,8.5008 2.48434668,8.4864 2.3343748,8.4612 C2.64556646,9.36516 3.56301943,10.02 4.6394426,10.038 C3.79585078,10.6464 2.73817409,11.01 1.58713991,11.01 C1.38842717,11.01 1.19083922,10.99956 1,10.97796 C2.09104543,11.62236 3.38530276,12 4.77291758,12 C9.30169343,12 11.7769793,8.53716 11.7769793,5.5344 C11.7769793,5.4372 11.7769793,5.34 11.7694807,5.2428 C12.253515,4.9224 12.6700619,4.5228 13,4.06596 L13,4.06596 Z"
        />
      </g>
    </svg>
  );
}

TwitterLogo.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

TwitterLogo.defaultProps = {
  className: '',
  width: 13,
  height: 14,
  color: '#00ACED',
};

export default TwitterLogo;
